(function () {
  "use strict";

  XlsConfirmCtrl.$inject = ['$scope', '$routeParams', 'xlsConsts'];
  angular
    .module('trainerWebApp.controllers')
    .controller('XlsConfirmCtrl', XlsConfirmCtrl);

  function XlsConfirmCtrl($scope, $routeParams, xlsConsts) {
    var xlsState = $scope.xlsState;
    var email = xlsConsts.emailFieldId;
    var username = xlsConsts.usernameFieldId;
    var userKeyEmail = email;
    var userKeyUsername = username;

    var activeUserEmails = xlsState.activeUserEmails;
    var activeUserUsernames = xlsState.activeUserUsernames;
    var userKeyEmailColumnIdx = _.find(xlsState.userFields, function (field) {
      return field.id === userKeyEmail;
    }).columnIdx;

    if ($scope.isUsernameEnabled) {
      var userKeyUsernameColumnIdx = _.find(xlsState.userFields, function (field) {
        return field.id === userKeyUsername;
      }).columnIdx;
    }

    xlsState.courseSeriesRequired = true;

    xlsState.confirmScreenOptions = {
      showCourses: showCourses(),
      showGroups: true,
      showRequiredCheckBox: showRequiredCheckBox()
    };

    function showCourses() {
      if ($routeParams.seriesId || $routeParams.courseId)
        return false;

      return xlsState.courses.length > 0 || xlsState.courses.length > 0
    }

    function showRequiredCheckBox() {
      if ($routeParams.seriesId || $routeParams.courseId)
        return true;

      return false;
    }

    function cellMapper(id) {
      var columnField = _.find(xlsState.userFields, function (field) {
        return field.id === id;
      });
      if (!columnField) return angular.noop();
      var columnIdx = columnField.columnIdx;

      return function (row, cell, value, columnDef, item) {
        return _.escape(item[columnIdx]);
      };
    }

    var mapFieldToColumn = this.mapFieldToColumn = function (field) {
      return {
        id: field.id,
        name: _.escape(field.name),
        width: 200,
        headerCssClass: "header-column",
        sortable: false,
        formatter: cellMapper(field.id)
      };
    };

    function rowMetadataProvider(row) {
      var item = this.getItem(row);
      if (!item) return;

      var emailKey, usernameKey;
      if (item[userKeyEmailColumnIdx]) {
        emailKey = item[userKeyEmailColumnIdx].toLowerCase();
      }
      if ($scope.isUsernameEnabled && item[userKeyUsernameColumnIdx]) {
        usernameKey = item[userKeyUsernameColumnIdx].toLowerCase();
      }

      if (activeUserEmails[emailKey] || ($scope.isUsernameEnabled && activeUserUsernames[usernameKey]))
        return {cssClasses: 'bg-warning'};
    }

    function errorFilterer(item) {
      return !item.$errors;
    }

    $scope.gridInfo = {
      options: {
        editable: false,
        enableCellNavigation: false,
        asyncEditorLoading: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        multiColumnSort: true
      },
      columns: [
        {id: "row", name: "Row", field: "id", width: 50, headerCssClass: "header-column", sortable: false}
      ].concat(_.map(xlsState.userFields, mapFieldToColumn)),
      rowMetadataProvider: rowMetadataProvider,
      filterFn: errorFilterer,
      data: xlsState.rows
    };

    $scope.selectGroupsOptions = {
      width: 'off',
      /*data: xlsState.groups,*/
      closeOnSelect: false,
      maximumInputLength: 40
    };

    var data;
    xlsState.confirmScreenOptions.showSeries = !_.isEmpty(xlsState.series);
    if (xlsState.confirmScreenOptions.showSeries) {
      data = [
        {text: 'Courses', children: xlsState.courses},
        {text: 'Series', children: xlsState.series}
      ];
    } else {
      data = xlsState.courses;
    }
    $scope.selectCourseSeriesOptions = {
      width: 'off',
      data: data
    };

    $scope.clearAllGroups = function () {
      xlsState.selectedGroups = null;
    };

    $scope.clearAllCourseSeries = function () {
      xlsState.selectedCourseSeries = null;
    };

  }

})();
